import BooleanFilter from 'scoreboard/reports/common/filter/boolean-filter'

function booleanFilterMeta(
	nameCode,
	trueCode = 'common.yes',
	falseCode = 'common.no'
) {
	return {
		nameCode,
		filterType: 'boolean',
		form: BooleanFilter,
		formOptions: {
			choices: [
				{id: "true", label: trueCode},
				{id: "false", label: falseCode}
			]
		}
	}
}

export default booleanFilterMeta

booleanFilterMeta.__filename__ = 'reports/common/filter/boolean-filter-meta.js'
